import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/'
import NProgress from 'nprogress'
import staticRoute from './staticRoute'
import common from '../service/common'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: staticRoute
})

import {applyRouter,diagRouter,adminRouter,commonRouter,stateRouter} from './routerTable'
const Layout = () => import(/* webpackChunkName: 'index' */ '../page/layout')

router.beforeEach((to,form,next)=>{
    if(common.getStorage('userInfo')){
        if(store.state.addRouter==0){
            //组织路由
            let roles=common.getStorage('roles');
            let newRouter=commonRouter
            if(roles.indexOf('gly')>-1){
                newRouter=newRouter.concat(adminRouter);
            }
            if(roles.indexOf('sqys')>-1){
                newRouter=newRouter.concat(applyRouter);
            }
            if(roles.indexOf('zdys')>-1){
                newRouter=newRouter.concat(diagRouter);
            }
            if(roles.indexOf('tjy')>-1){
                newRouter=newRouter.concat(stateRouter);
            }
            newRouter=newRouter.concat(commonRouter);
            let endRouter=[
                {
                    path: '/home',
                    component: Layout,
                    children: newRouter
                }
            ];
            router.addRoutes(endRouter);
            store.state.addRouter=1;
            next(to.path);
        }
        else{
            next();
        }
    }else{
        next();
    }
})
router.afterEach(()=>{
    NProgress.done(); // 结束Progress
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js